export enum Mutations {
    createGoal = 'createGoal',
}
